import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import Layout from '../components/Layout';
import api from '../api';

export default function ReadingRegistration() {
    const [books, setBooks] = useState([]);
    const [selectedBook, setSelectedBook] = useState('');
    const [report, setReport] = useState('');
    const [message, setMessage] = useState('');
    const [error, setError] = useState('');

    useEffect(() => {
        const fetchBooks = async () => {
            try {
                const { data } = await api.get('/books/');
                setBooks(data);
                if (data.length > 0) {
                    setSelectedBook(data[0].id);
                }
            } catch (err) {
                console.error("Failed to fetch books", err);
            }
        };
        fetchBooks();
    }, []);

    const handleSubmit = async (e) => {
        e.preventDefault();
        setMessage('');
        setError('');
        try {
            await api.post('/records/', {
                book: selectedBook,
                report: report,
            });
            setMessage('독서 기록이 성공적으로 등록되었습니다.');
            setReport('');
        } catch (err) {
            setError('등록에 실패했습니다. 이미 기록한 책인지 확인해주세요.');
            console.error(err);
        }
    };

    return (
        <Layout>
            <Link to="/main" className="back-link">메인으로</Link>
            <div style={{ maxWidth: '500px', margin: 'auto' }}>
                <h1>독서 등록</h1>
                <form onSubmit={handleSubmit}>
                    <p>읽은 책</p>
                    <select value={selectedBook} onChange={(e) => setSelectedBook(e.target.value)}>
                        {books.map(book => (
                            <option key={book.id} value={book.id}>
                                {book.name}
                            </option>
                        ))}
                    </select>
                    <p>감상문</p>
                    <textarea
                        rows="5"
                        value={report}
                        onChange={(e) => setReport(e.target.value)}
                        required
                    ></textarea>
                    <button type="submit">등록</button>
                </form>
                {message && <p className="message success">{message}</p>}
                {error && <p className="message error">{error}</p>}
            </div>
        </Layout>
    );
}

